
import "./styles.scss"
import { observer } from 'mobx-react';
import { UiIcon } from 'shared/uikit';
import { ICONS } from 'shared/constants';
import { profileDashboardStore } from './../../../../store/ProfileDashBoardStore';
import { useMedia } from 'shared/hooks';
import { UserDashboardWidgetModel } from 'shared/models';
import { IUserDashboardLeagueGoal } from 'shared/models/UserDashboardModel.ts';

type Props = {
   widget: UserDashboardWidgetModel,
   onOpenLeagueInfo?: () => void;
}

const CROWN_ICON_COLOR: Record<string, string> = {
    bronze:  "#FF8C69",
    silver: "#B3BAC9",
    gold: "#FFC439"
};

const DECORATION_IMAGES: Record<string, Record<string, string>> = {
    sales: {
        iron: require("./../../assets/league-sales-iron.png"),
        bronze: require("./../../assets/league-sales-bronze.png"),
        silver: require("./../../assets/league-sales-silver.png"),
        gold: require("./../../assets/league-sales-gold.png"),
    },
    plan: {
        iron: require("./../../assets/league-plan-iron.png"),
        bronze: require("./../../assets/league-plan-bronze.png"),
        silver: require("./../../assets/league-plan-silver.png"),
        gold: require("./../../assets/league-plan-gold.png"),
    }
};

export const PPDWidgetLeagueStatus = observer(({widget, onOpenLeagueInfo}: Props) => {
    const store = profileDashboardStore;

    const item = widget.items.find(i => i.id === store.activeLeagueTab);
    if (!item) return null;

    const isLeader =
        ['bronze', 'silver', 'gold'].includes(item.league.id) &&
        item.rating.is_league_leader;
    const leagueId = item.league.id as keyof typeof CROWN_ICON_COLOR;
    const decorationImage = DECORATION_IMAGES[item.id]?.[leagueId];

    const  { isMobileOrTablet } = useMedia()

    return (
        <div className={`league-status league-status--${leagueId}`}>
            <div className="league-status__content">
                <div className="league-status__header">
                    <h2 className="league-status__title">{item.league.name}</h2>

                    <div className="league-status__rating">
                        <span className="league-status__rating-title">{item.name}</span>

                        <div className="league-status__position">
                            <div className="league-status__current-position">
                                {isLeader ? (
                                    <div className="league-status__crown">
                                        <UiIcon
                                            size={16}
                                            icon={ICONS.CROWN}
                                            color={CROWN_ICON_COLOR[leagueId]}
                                        />
                                    </div>
                                ) : item.rating.direction !== "stable" ? (
                                    <UiIcon
                                        size={ isMobileOrTablet ? 24 : 27}
                                        icon={ICONS.ARROW_DOWN}
                                        color={"#15171C"}
                                        className={`league-status__trend-icon ${
                                            item.rating.direction === "up" ? "league-status__trend-icon--up" : ""
                                        }`}
                                    />
                                ) : null}
                                <span className="league-status__position-number">
                                    {item.rating.current}
                                </span>
                            </div>
                            <span className="league-status__position-separator">из</span>
                            <span className="league-status__position-total">
                                {item.rating.total}
                            </span>
                        </div>
                    </div>

                    {
                        item?.goals?.length > 0 && (
                            <ul className="league-status__goals">
                                {item.goals.map((goal: IUserDashboardLeagueGoal, i: number) => (
                                    <li key={i} className="league-status__goal">
                                        <span className="league-status__goal-label">{goal.name}</span>
                                        <span className="league-status__goal-value">
                                    +{goal.value.amount.toLocaleString("ru-RU")} ₽
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        )
                    }

                </div>

                <div className="league-status__footer">
                    <button type="button" className="league-status__info-button" onClick={onOpenLeagueInfo}>
                        <UiIcon icon={ICONS.HELP_CIRCLE} size={16} color="#2C2F35" className="league-status__info-icon"/>
                        О рейтинге
                    </button>
                </div>
            </div>

            <div className="league-status__decoration">
                <img
                    className="league-status__decoration-image"
                    src={decorationImage}
                />
            </div>
        </div>
    );
});
